module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/address/postcode.js
 ** module id = 584
 ** module chunks = 0
 **/